/* Storefront safeguards. Checkout validation must also be configured to cover direct checkout/API routes. */
window.BlackBearFlooring = (() => {
  const tiles = new Set(["48057130287423", "48057450660159", "56672610222454", "57459179422070", "58813179986294", "59075403874678", "59075404988790"]);
  return {
    minimum: (id) => tiles.has(String(id)) ? 8 : 1,
    message: 'Minimum order: 8 full tiles of this flooring. Increase the quantity to 8 or remove the tiles.'
  };
})();

(() => {
  const valueProperty = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
  const guarded = new WeakSet();
  const selections = new WeakMap();
  const variantFor = (input) => input.closest('product-info')?.querySelector('input.product-variant-id')?.value || input.form?.querySelector('input[name="id"]')?.value;
  const minimumFor = (input) => window.BlackBearFlooring.minimum(variantFor(input));
  const adjusted = (input, value) => {
    if (minimumFor(input) !== 8) return value;
    const number = Number(value);
    return Number.isFinite(number) && number >= 8 ? String(Math.ceil(number)) : '8';
  };
  const protect = (input) => {
    const selected = variantFor(input);
    const previous = selections.get(input);
    selections.set(input, selected);
    if (minimumFor(input) !== 8) {
      if (guarded.has(input)) {
        if (input.min !== '1') input.min = '1';
        if (input.dataset.min !== '1') input.dataset.min = '1';
        if (previous !== selected) valueProperty.set.call(input, '1');
      }
      return;
    }
    if (!guarded.has(input)) {
      Object.defineProperty(input, 'value', {
        configurable: true,
        get() { return valueProperty.get.call(this); },
        set(value) { valueProperty.set.call(this, adjusted(this, value)); }
      });
      guarded.add(input);
    }
    if (input.min !== '8') input.min = '8';
    if (input.dataset.min !== '8') input.dataset.min = '8';
    const next = adjusted(input, valueProperty.get.call(input));
    if (valueProperty.get.call(input) !== next) valueProperty.set.call(input, next);
  };
  const synchronize = () => document.querySelectorAll('input[name="quantity"]').forEach(protect);
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; synchronize(); });
  };
  const start = () => {
    synchronize();
    new MutationObserver(schedule).observe(document.body, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['min', 'data-min', 'value']
    });
    document.addEventListener('change', (event) => {
      if (event.target.matches('input[name="quantity"]')) protect(event.target);
      schedule();
    }, true);
    const inputTimers = new WeakMap();
    document.addEventListener('input', (event) => {
      const input = event.target;
      if (!input.matches('input[name="quantity"]') || minimumFor(input) !== 8) return;
      clearTimeout(inputTimers.get(input));
      inputTimers.set(input, setTimeout(() => protect(input), 250));
    }, true);
    document.addEventListener('focusout', (event) => {
      if (event.target.matches('input[name="quantity"]')) protect(event.target);
    }, true);
    document.addEventListener('submit', synchronize, true);
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('pageshow', schedule);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();


// Mirror Yuko "Flooring Min Order": 8–450 units per selected full-tile variant.
// Edge/corner variants and explicit line removal are deliberately unaffected.
(() => {
  'use strict';
  const roots = new WeakSet();
  const variant = key => String(key || '').split(':')[0];
  const restricted = element => window.BlackBearFlooring.minimum(variant(element.dataset.lineKey)) === 8;
  const inputs = root => [...root.querySelectorAll('input[data-line-quantity-input]')];
  const quantity = input => Number(input.dataset.lineQuantity || input.value) || 0;
  const totalFor = (root, key) => inputs(root)
    .filter(input => variant(input.dataset.lineKey) === variant(key))
    .reduce((sum, input) => sum + quantity(input), 0);
  function bounds(root, input) {
    const others = totalFor(root, input.dataset.lineKey) - quantity(input);
    return { min: Math.max(1, 8 - others), max: Math.max(1, 450 - others) };
  }
  function sync(root) {
    for (const input of inputs(root)) {
      if (!restricted(input)) continue;
      const limit = bounds(root, input);
      input.min = String(limit.min);
      input.max = String(limit.max);
      const controls = input.parentElement;
      const decrement = controls.querySelector('[data-line-action="decrement"]');
      const increment = controls.querySelector('[data-line-action="increment"]');
      const total = totalFor(root, input.dataset.lineKey);
      if (decrement) {
        decrement.disabled = total <= 8;
        decrement.title = total <= 8 ? 'Minimum 8 full tiles. Use Remove to remove this item.' : '';
      }
      if (increment && total >= 450) increment.disabled = true;
      if (!controls.parentElement.parentElement.querySelector('[data-bb-flooring-limit]')) {
        const note = document.createElement('small');
        note.dataset.bbFlooringLimit = '';
        note.textContent = 'Minimum 8 full tiles of this flooring. Use Remove to remove it.';
        note.style.cssText = 'display:block;font-size:11px;line-height:1.4;color:#5f6368;flex-basis:100%;';
        controls.parentElement.parentElement.append(note);
      }
    }
  }
  function connect() {
    document.querySelectorAll('section-store--cart-block').forEach(host => {
      const root = host.shadowRoot;
      if (!root || roots.has(root)) return;
      roots.add(root);
      let pending = false;
      const schedule = () => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => { pending = false; sync(root); });
      };
      root.addEventListener('click', event => {
        const button = event.target.closest?.('[data-line-action]');
        if (!button || !restricted(button)) return;
        const action = button.dataset.lineAction;
        if (action === 'remove') return;
        const total = totalFor(root, button.dataset.lineKey);
        if ((action === 'decrement' && total <= 8) || (action === 'increment' && total >= 450)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
      root.addEventListener('input', event => {
        const input = event.target;
        if (!input.matches?.('input[data-line-quantity-input]') || !restricted(input)) return;
        const value = Number(input.value);
        const limit = bounds(root, input);
        // Let shoppers finish typing, then clamp on change before the cart handles it.
        if (value !== 0 && (!Number.isInteger(value) || value < limit.min || value > limit.max)) {
          event.stopImmediatePropagation();
        }
      }, true);
      const normalize = (input) => {
        if (!input.matches?.('input[data-line-quantity-input]') || !restricted(input)) return;
        const value = Number(input.value);
        if (input.value !== '' && value === 0) return;
        const limit = bounds(root, input);
        const next = String(Math.min(limit.max, Math.max(limit.min, Number.isFinite(value) ? Math.ceil(value) : limit.min)));
        if (input.value !== next) {
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      root.addEventListener('focusout', event => normalize(event.target), true);
      root.addEventListener('blur', event => normalize(event.target), true);
      root.addEventListener('change', event => {
        const input = event.target;
        if (!input.matches?.('input[data-line-quantity-input]') || !restricted(input)) return;
        const value = Number(input.value);
        if (input.value !== '' && value === 0) return; // Explicit quantity-zero removal.
        const limit = bounds(root, input);
        input.value = String(Math.min(limit.max, Math.max(limit.min, Number.isFinite(value) ? Math.ceil(value) : limit.min)));
      }, true);
      new MutationObserver(schedule).observe(root, {
        subtree: true, childList: true, attributes: true, attributeFilter: ['data-line-quantity']
      });
      sync(root);
    });
  }
  const start = () => {
    connect();
    new MutationObserver(connect).observe(document.body, { childList: true, subtree: true });
    customElements.whenDefined('section-store--cart-block').then(connect);
    window.addEventListener('section-store:cart:updated', connect);
    window.addEventListener('section-store:cart:opened', connect);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

